import { getContext, setContext } from 'svelte'
import type { Writable } from 'svelte/store'
import { writable } from 'svelte/store'

interface HashMap<T> {
	[key: string]: T
}

export interface Upsertable<T> extends Writable<HashMap<T>> {
	upsert: (name: string, item: T) => void
}

export interface ErrorMessage {
	icon?: string
	text: string
}

function createErrors(): Upsertable<ErrorMessage> {
	const { subscribe, set, update } = writable<HashMap<ErrorMessage>>({})
	return {
		subscribe,
		set,
		update,
		upsert: (name: string, errorMessage: ErrorMessage) =>
			update((errors) => ({ ...errors, [name]: errorMessage })),
	}
}

const errorContext = 'errors'

export function getContextErrors() {
	let errors = getContext<Upsertable<ErrorMessage>>(errorContext)
	if (errors) {
		return errors
	} else {
		errors = createErrors()
		setContext<Upsertable<ErrorMessage>>(errorContext, errors)
		return errors
	}
}
